module.exports = __webpack_public_path__ + "img/Frame 5129.3ffe1233.jpg";